import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/yanre/Logo";
import { LanguageSelector } from "@/components/lp/LandingHeader";
import { INSTITUTIONAL_WEBSITE_URL, WHATSAPP_NUMBER, whatsappMessage } from "@/config";
import { track } from "@/lib/track";
import { useLocale } from "@/i18n/LocaleContext";
import { PT_LOCALES, ptsPath } from "@/i18n";

// PT Studio header — same visual language as the LP header, minimal nav.
// Language selector copied exactly from the OYG header, routed to the PT family.
export const PTHeader = () => {
  const { t, locale } = useLocale();
  const waHref = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage({ page: "personal-trainer-studio", lang: locale }))}`;

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-carbon-700/60 bg-carbon-950/85 backdrop-blur-md" data-testid="pt-header">
      <div className="container-edge flex h-16 items-center justify-between sm:h-20">
        <a href="#top" aria-label="YANRE FITNESS EUROPE" data-testid="pt-header-logo">
          <Logo />
        </a>
        <div className="flex items-center gap-3 sm:gap-5">
          <a
            href={INSTITUTIONAL_WEBSITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("visit_website_click", { placement: "header", page: "personal-trainer-studio" })}
            className="hidden items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] text-titanium/60 transition-colors hover:text-white sm:inline-flex"
            data-testid="pt-header-visit-website"
          >
            {t("nav.visitWebsite", "Visit Website")}
            <ArrowUpRight className="h-3 w-3" />
          </a>
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { placement: "header", page: "personal-trainer-studio" })}
            className="hidden font-mono text-[11px] uppercase tracking-[0.2em] text-titanium/60 transition-colors hover:text-white md:inline-flex"
            data-testid="pt-header-whatsapp"
          >
            {t("pts.nav.talk", "Talk to a Specialist")}
          </a>
          <LanguageSelector locales={PT_LOCALES} pathFn={ptsPath} />
          <a
            href="#studio-project"
            onClick={() => track("cta_start_project", { placement: "header", page: "personal-trainer-studio" })}
            className="btn-signal !px-5 !py-2.5 text-[11px]"
            data-testid="pt-header-cta"
          >
            {t("pts.header.cta", "Build My Studio")}
            <ArrowRight className="h-3.5 w-3.5" />
          </a>
        </div>
      </div>
    </header>
  );
};
